webpackJsonp([55],{

/***/ 1018:
/***/ (function(module, exports) {

module.exports = {"name":"ant-design-vue","version":"1.7.2","title":"Ant Design Vue","description":"An enterprise-class UI design language and Vue-based implementation","keywords":["ant","design","antd","vue","vueComponent","component","components","ui","framework","frontend"],"main":"lib/index.js","module":"es/index.js","typings":"types/index.d.ts","files":["dist","lib","es","types","scripts"],"scripts":{"dev":"webpack-dev-server","start":"cross-env NODE_ENV=development webpack-dev-server --config webpack.config.js","test":"cross-env NODE_ENV=test jest --config .jest.js","compile":"node antd-tools/cli/run.js compile","pub":"node antd-tools/cli/run.js pub","pub-with-ci":"node antd-tools/cli/run.js pub-with-ci","prepublish":"node antd-tools/cli/run.js guard","pre-publish":"node ./scripts/prepub","prettier":"prettier -c --write '**/*'","pretty-quick":"pretty-quick","dist":"node antd-tools/cli/run.js dist","lint":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./components","lint:site":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./antdv-demo","lint:docs":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue,.md ./antdv-demo/docs/**/demo/**","lint:style":"stylelint \"{site,components}/**/*.less\" --syntax less","codecov":"codecov","postinstall":"node scripts/postinstall || echo \"ignore\""},"repository":{"type":"git","url":"git+https://github.com/vueComponent/ant-design-vue.git"},"license":"MIT","bugs":{"url":"https://github.com/vueComponent/ant-design-vue/issues"},"homepage":"https://www.antdv.com/","peerDependencies":{"vue":">=2.6.0","vue-template-compiler":">=2.6.0"},"devDependencies":{"@commitlint/cli":"^8.0.0","@commitlint/config-conventional":"^8.0.0","@octokit/rest":"^16.0.0","@vue/cli-plugin-eslint":"^4.0.0","@vue/server-test-utils":"1.0.0-beta.16","@vue/test-utils":"1.0.0-beta.16","acorn":"^7.0.0","autoprefixer":"^9.6.0","axios":"^0.19.0","babel-cli":"^6.26.0","babel-core":"^6.26.0","babel-eslint":"^10.0.1","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-jest":"^23.6.0","babel-loader":"^7.1.2","babel-plugin-import":"^1.1.1","babel-plugin-inline-import-data-uri":"^1.0.1","babel-plugin-istanbul":"^6.0.0","babel-plugin-syntax-dynamic-import":"^6.18.0","babel-plugin-syntax-jsx":"^6.18.0","babel-plugin-transform-class-properties":"^6.24.1","babel-plugin-transform-decorators":"^6.24.1","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-es3-member-expression-literals":"^6.22.0","babel-plugin-transform-es3-property-literals":"^6.22.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-plugin-transform-runtime":"~6.23.0","babel-plugin-transform-vue-jsx":"^3.7.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.6.1","case-sensitive-paths-webpack-plugin":"^2.1.2","chalk":"^3.0.0","cheerio":"^1.0.0-rc.2","codecov":"^3.0.0","colorful":"^2.1.0","commander":"^4.0.0","compare-versions":"^3.3.0","cross-env":"^7.0.0","css-loader":"^3.0.0","deep-assign":"^2.0.0","enquire-js":"^0.2.1","eslint":"^6.8.0","eslint-config-prettier":"^6.10.1","eslint-plugin-html":"^6.0.0","eslint-plugin-markdown":"^2.0.0-alpha.0","eslint-plugin-vue":"^6.2.2","fetch-jsonp":"^1.1.3","fs-extra":"^8.0.0","glob":"^7.1.2","gulp":"^4.0.1","gulp-babel":"^7.0.0","gulp-strip-code":"^0.1.4","html-webpack-plugin":"^3.2.0","husky":"^4.0.0","istanbul-instrumenter-loader":"^3.0.0","jest":"^24.0.0","jest-serializer-vue":"^2.0.0","jest-transform-stub":"^2.0.0","js-base64":"^3.0.0","json-templater":"^1.2.0","jsonp":"^0.2.1","less":"^3.9.0","less-loader":"^6.0.0","less-plugin-npm-import":"^2.1.0","lint-staged":"^10.0.0","marked":"0.3.18","merge2":"^1.2.1","mini-css-extract-plugin":"^0.10.0","minimist":"^1.2.0","mkdirp":"^0.5.1","mockdate":"^2.0.2","nprogress":"^0.2.0","optimize-css-assets-webpack-plugin":"^5.0.1","postcss":"^7.0.6","postcss-loader":"^3.0.0","prettier":"^1.18.2","pretty-quick":"^2.0.0","querystring":"^0.2.0","raw-loader":"^4.0.0","reqwest":"^2.0.5","rimraf":"^3.0.0","rucksack-css":"^1.0.2","selenium-server":"^3.0.1","semver":"^7.0.0","style-loader":"^1.0.0","stylelint":"^13.0.0","stylelint-config-prettier":"^8.0.0","stylelint-config-standard":"^19.0.0","terser-webpack-plugin":"^3.0.3","through2":"^3.0.0","url-loader":"^3.0.0","vue":"^2.6.11","vue-antd-md-loader":"^1.1.0","vue-clipboard2":"0.3.1","vue-draggable-resizable":"^2.1.0","vue-eslint-parser":"^7.0.0","vue-i18n":"^8.3.2","vue-infinite-scroll":"^2.0.2","vue-jest":"^2.5.0","vue-loader":"^15.6.2","vue-router":"^3.0.1","vue-server-renderer":"^2.6.11","vue-template-compiler":"^2.6.11","vue-virtual-scroller":"^1.0.0","vuex":"^3.1.0","webpack":"^4.28.4","webpack-cli":"^3.2.1","webpack-dev-server":"^3.1.14","webpack-merge":"^4.1.1","webpackbar":"^4.0.0","xhr-mock":"^2.5.1"},"dependencies":{"@ant-design/icons":"^2.1.1","@ant-design/icons-vue":"^2.0.0","@simonwep/pickr":"~1.7.0","add-dom-event-listener":"^1.0.2","array-tree-filter":"^2.1.0","async-validator":"^3.0.3","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-runtime":"6.x","classnames":"^2.2.5","component-classes":"^1.2.6","dom-align":"^1.10.4","dom-closest":"^0.2.0","dom-scroll-into-view":"^2.0.0","enquire.js":"^2.1.6","intersperse":"^1.0.0","is-mobile":"^2.2.1","is-negative-zero":"^2.0.0","ismobilejs":"^1.0.0","json2mq":"^0.2.0","lodash":"^4.17.5","moment":"^2.21.0","mutationobserver-shim":"^0.3.2","node-emoji":"^1.10.0","omit.js":"^1.0.0","raf":"^3.4.0","resize-observer-polyfill":"^1.5.1","shallow-equal":"^1.0.0","shallowequal":"^1.0.2","vue-ref":"^2.0.0","warning":"^4.0.0"},"sideEffects":["site/*","components/style.js","components/**/style/*","*.vue","*.md","dist/*","es/**/style/*","lib/**/style/*","*.less"]}

/***/ }),

/***/ 1039:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service__ = __webpack_require__(511);




var numeral = __webpack_require__(1041);
var moment = __webpack_require__(3);
var ThaiBaht = __webpack_require__(1042);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin({
  data: function data() {
    return {
      CompanyConfig: __WEBPACK_IMPORTED_MODULE_2__static_config___default.a,
      branchData: []
    };
  },

  methods: {
    checkUser: function checkUser() {
      if (sessionStorage.user) {
        this.$store.state.token = sessionStorage.token;
        this.$store.state.user = JSON.parse(sessionStorage.user);
      } else {
        this.$store.commit('clearState');
        window.location = '/login';
      }
    },
    getBranch: function getBranch() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */].branchList(sessionStorage.Url, {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }, function (result) {
        if (result.response === 'success') {
          _this.$store.state.branch_list = result.data;
        } else {
          _this.alert_msg('warning', 'เข้าสู่ระบบ', result.message);
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    getLastDate: function getLastDate(Data) {
      var res = Data.split('-');
      var month = res[1]; // January
      var year = res[0];
      var d = new Date(year, month, 0);
      return moment(d).format('DD');
    },
    dateYearThai: function dateYearThai(date) {
      return moment(date).format('YYYY');
    },
    dateMonth: function dateMonth(date) {
      return moment(date).format('YYYY-MM');
    },
    alert_msg: function alert_msg(type, title, text) {
      this.$notice[type]({
        title: title,
        description: text
      });
    },
    ToDoDev: function ToDoDev() {
      this.alert_msg('warning', 'แจ้งเตือนระบบ', 'ระบบกำลังพัฒนาอยู่นะจ๊ะ *_*!');
    },
    dateFormatAndTime: function dateFormatAndTime(date) {
      moment.locale();
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
    dateFormatAndTimeDat: function dateFormatAndTimeDat(date) {
      moment.locale();
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    dateDMY: function dateDMY(date) {
      return moment(date).format('YYYYMMDD');
    },
    dateFormat: function dateFormat(date) {
      moment.locale();
      return moment(date).format('L');
    },
    dateFormatDMY: function dateFormatDMY(date) {
      moment.locale();
      return moment(date).format('DD/MM/YYYY');
    },
    dateFormatDMY2: function dateFormatDMY2(date) {
      moment.locale();
      return moment(date).format('YYYY-MM-DD');
    },
    dateFormatMY: function dateFormatMY(date) {
      moment.locale();
      return moment(date).format('MM/YYYY');
    },
    monthFormat: function monthFormat(str) {
      switch (str) {
        case '01':
          return 'ม.ค';
        case '02':
          return 'ก.พ';
        case '03':
          return 'มี.ค';
        case '04':
          return 'เม.ย';
        case '05':
          return 'พ.ค';
        case '06':
          return 'มิ.ย';
        case '07':
          return 'ก.ค';
        case '08':
          return 'ส.ค';
        case '09':
          return 'ก.ย';
        case '10':
          return 'ต.ค';
        case '11':
          return 'พ.ย';
        default:
          return 'ธ.ค';
      }
    },
    monthYearFormat: function monthYearFormat(str) {
      var date = str.split('-');
      switch (date[1]) {
        case '01':
          return 'มกราคม ' + date[0];
        case '02':
          return 'กุมภาพันธ์ ' + date[0];
        case '03':
          return 'มีนาคม ' + date[0];
        case '04':
          return 'เมษายน ' + date[0];
        case '05':
          return 'พฤษภาคม ' + date[0];
        case '06':
          return 'มิถุนายน ' + date[0];
        case '07':
          return 'กรกฎาคม ' + date[0];
        case '08':
          return 'สิงหาคม ' + date[0];
        case '09':
          return 'กันยายน ' + date[0];
        case '10':
          return 'ตุลาคม ' + date[0];
        case '11':
          return 'พฤศจิกายน ' + date[0];
        default:
          return 'ธันวาคม ' + date[0];
      }
    },
    dateFullFormat: function dateFullFormat(str) {
      var date = str.split('-');
      switch (date[1]) {
        case '01':
          return date[2] + ' มกราคม ' + date[0];
        case '02':
          return date[2] + ' กุมภาพันธ์ ' + date[0];
        case '03':
          return date[2] + ' มีนาคม ' + date[0];
        case '04':
          return date[2] + ' เมษายน ' + date[0];
        case '05':
          return date[2] + ' พฤษภาคม ' + date[0];
        case '06':
          return date[2] + ' มิถุนายน ' + date[0];
        case '07':
          return date[2] + ' กรกฎาคม ' + date[0];
        case '08':
          return date[2] + ' สิงหาคม ' + date[0];
        case '09':
          return date[2] + ' กันยายน ' + date[0];
        case '10':
          return date[2] + ' ตุลาคม ' + date[0];
        case '11':
          return date[2] + ' พฤศจิกายน ' + date[0];
        default:
          return date[2] + ' ธันวาคม ' + date[0];
      }
    },
    numberFormatDecimal: function numberFormatDecimal(str) {
      return numeral(str).format('0,0.00');
    },
    numberFormat: function numberFormat(str) {
      return numeral(str).format('0,0');
    },
    moneyText: function moneyText(str) {
      return ThaiBaht(str);
    },
    convert_vs: function convert_vs(val) {
      var data = [];
      var len = 3;
      if (val.length > 3) {
        len = val.length;
      }
      var vallen = val.length;
      for (var i = 0; i < len; i++) {
        var v = val.split('');
        if (len - i === vallen) {
          var ss = len - i;
          if (ss === vallen) {
            if (val.length === 1) {
              data.push(val);
            } else {
              if (len > val.length) {
                data.push(v[i - 1]);
              } else {
                data.push(v[i]);
              }
            }
          } else {
            data.push(v[i - 1]);
          }
          vallen--;
        } else {
          data.push('0');
        }
      }
      var versions = '';
      for (var l = 0; l < data.length; l++) {
        versions += data[l];
        if (l < data.length - 1) {
          versions += '.';
        }
      }
      return versions;
    },
    getParam: function getParam(param) {
      var url = new URL(window.location.href);
      var c = url.searchParams.get(param);
      return c;
    },
    convertTitleCalendar: function convertTitleCalendar(str) {
      var date = str.split(' ');
      switch (date[0]) {
        case 'มกราคม':
          return '01-' + date[1];
        case 'กุมภาพันธ์':
          return '02-' + date[1];
        case 'มีนาคม':
          return '03-' + date[1];
        case 'เมษายน':
          return '04-' + date[1];
        case 'พฤษภาคม':
          return '05-' + date[1];
        case 'มิถุนายน':
          return '06-' + date[1];
        case 'กรกฎาคม':
          return '07-' + date[1];
        case 'สิงหาคม':
          return '08-' + date[1];
        case 'กันยายน':
          return '09-' + date[1];
        case 'ตุลาคม':
          return '10-' + date[1];
        case 'พฤศจิกายน':
          return '11-' + date[1];
        default:
          return '12-' + date[1];
      }
    },
    colorItemDefalt: function colorItemDefalt(val) {
      switch (val) {
        case 0:
          return 'white';
        case 1:
          return 'green';
        default:
          return 'white';
      }
    }
  }
});

/***/ }),

/***/ 1040:
/***/ (function(module, exports) {

module.exports = {"last_update":1585663558273,"logo_path":"/static/logo.jpg","title_web":"​POS MIS","base_api":"https://rice-api.maeriminterfood.com/"}

/***/ }),

/***/ 1043:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_slider__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    SliderView: __WEBPACK_IMPORTED_MODULE_0__components_slider__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.$store.state.screenWidth = window.innerWidth;
      this.$store.state.screenHeight = window.innerHeight;
    }
  }
});

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_mock_menus_json__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_mock_menus_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_mock_menus_json__);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      menu_data: []
    };
  },

  methods: {
    checkDisplay: function checkDisplay(menus) {
      if (menus === 0) {
        $('.nav-treeview').hide();
        if (this.$store.state.screenWidth <= 736) {
          $('body').addClass('sidebar-collapse');
          $('body').removeClass('sidebar-open');
        }
      }
    },
    subCheckDisplay: function subCheckDisplay() {
      if (this.$store.state.screenWidth <= 736) {
        $('body').addClass('sidebar-collapse');
        $('body').removeClass('sidebar-open');
      }
    }
  },
  mounted: function mounted() {
    if (sessionStorage.user) {
      this.$store.state.token = sessionStorage.token;
      this.$store.state.user = JSON.parse(sessionStorage.user);
    }
    // this.menu_data = menus
    console.log(JSON.parse(sessionStorage.menu_page));
    this.menu_data = JSON.parse(sessionStorage.menu_page);
    console.log(this.menu_permission);
  }
});

/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  callMisApi: function callMisApi(URL, header, body, success, error) {
    var payload = {
      endpoint_dyn: URL,
      payload: body
    };
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(sessionStorage.Url + 'mis/v1/dyn/v1/request/to/client', payload, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  uploadImage: function uploadImage(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'upload/v1/upload/image', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  isLogin: function isLogin(URL, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'auth/v1/signin', body).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addUser: function addUser(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'auth/v1/add/user', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  listUser: function listUser(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'auth/v1/list/user', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  removeUser: function removeUser(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'auth/v1/remove/user/code', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getRole: function getRole(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'auth/v1/list/role', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  userDetail: function userDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'auth/v1/get/user/code', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  userUpdate: function userUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'auth/v1/update/user/code', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  confighDetail: function confighDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'company/v1/branch/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  confighUpdate: function confighUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'company/v1/branch/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShift: function getHostShift(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.get('https://rice-api-dev.extensionsoft.biz/company/v1/host/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  branchList: function branchList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.get(URL + 'mis/v1/branch/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  branchConfigUpdate: function branchConfigUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'mis/v1/branch/config/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  DashBoard: function DashBoard(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/profit', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  GetMisMenuRole: function GetMisMenuRole(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'auth/v1/mis/get/menu/role', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  UpdateMisMenuRole: function UpdateMisMenuRole(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'auth/v1/mis/update/role', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  DashStandardCostProfit: function DashStandardCostProfit(URL, header, body, success, error) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/standardcost/profit', body, header).then(function (response) {
                success(response.data);
              }, function (response) {
                error(response);
              });

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_slider_js__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb89840_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_vue__ = __webpack_require__(523);
var normalizeComponent = __webpack_require__(193)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_slider_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb89840_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Vuex_store__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ant_design_vue__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mlqt_vue_back_top__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mlqt_vue_back_top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mlqt_vue_back_top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crip_vue_notice__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crip_vue_notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_crip_vue_notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_mixin__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ant_design_vue_dist_antd_css__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ant_design_vue_dist_antd_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ant_design_vue_dist_antd_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_index_css__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_css_index_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__mlqt_vue_back_top___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_ant_design_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_crip_vue_notice___default.a, {
  duration: 1.5,
  styles: { top: '15px', right: '15px' },
  className: 'notices',
  icons: {
    info: 'fas fa-info-circle',
    success: 'fas fa-check-circle',
    warning: 'fas fa-exclamation-circle',
    error: 'fas fa-times-circle',
    close: 'fas fa-times'
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__Vuex_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0b57494_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(527);
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0b57494_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 522:
/***/ (function(module, exports) {

module.exports = [{"name":"Dashboard","icon":"fas fa-tachometer-alt","path":"/","group_id":1,"menu_id":1,"menus":[]},{"name":"สินค้าคงคลัง","icon":"fas fa-store","path":"","group_id":2,"menu_id":0,"menus":[{"name":"จัดการสินค้า","path":"/itemlist","group_id":2,"menu_id":2},{"name":"บันทึกรับสินค้าเข้า","path":"/receivelist","group_id":2,"menu_id":3}]},{"name":"ข้อมูลส่วนกลาง","icon":"fas fa-warehouse","path":"","group_id":20,"menu_id":0,"menus":[{"name":"จัดการสินค้าส่วนกลาง","path":"/itemprice","group_id":20,"menu_id":1},{"name":"จัดการสินค้าส่วนกลาง 2","path":"/itemprice","group_id":20,"menu_id":2}]},{"name":"จัดการเจ้าหนี้","icon":"fas fa-user-secret","path":"/vendor","group_id":6,"menu_id":15,"menus":[]},{"name":"จัดการลูกหนี้","icon":"fas fa-user-tie","path":"/customer","group_id":7,"menu_id":16,"menus":[]},{"name":"รายการพักบิล","icon":"fas fa-print","path":"/printinv","group_id":10,"menu_id":19,"menus":[]},{"name":"จัดการใบกำกับภาษี","icon":"fas fa-print","path":"/tax_invoice","group_id":10,"menu_id":0,"menus":[]},{"name":"รายงาน","icon":"fas fa-chart-line","path":"","group_id":3,"menu_id":0,"menus":[{"name":"ยอดขายประจำวัน","path":"/report_sale","group_id":3,"menu_id":5},{"name":"รายงานกำไรขั้นต้น","path":"/reportcostofsales","group_id":3,"menu_id":7},{"name":"รายงานนำส่งเงิน","path":"/reportdaily","group_id":3,"menu_id":13},{"name":"รายงานค่าใช้จ่าย","path":"/reportexpend","group_id":3,"menu_id":8},{"name":"รายงานสินค้าคงคลัง","path":"/reportstock","group_id":3,"menu_id":9},{"name":"รายงานสรุปการขาย","path":"/reportsalesummary","group_id":3,"menu_id":14},{"name":"รายงานเคลื่อนไหวสินค้า","path":"/reportmovement","group_id":3,"menu_id":10},{"name":"รายงานพักบิลตามวันที่","path":"/reportholdingcus","group_id":3,"menu_id":20},{"name":"รายงานพักบิลค้างชำระ","path":"/reportholdingremain","group_id":3,"menu_id":22},{"name":"รายงานสรุปยอดขายตามลูกค้า","path":"/reportsalebycustomer","group_id":3,"menu_id":24},{"name":"รายงานยกเลิกบิล","path":"/reportbillcancel","group_id":3,"menu_id":21},{"name":"รายงานขายตามประเภทรับชำระ","path":"/reportsaletype","group_id":3,"menu_id":23},{"name":"ยอดขายตามสินค้าประจำวัน","path":"/reportitem","group_id":3,"menu_id":6}]},{"name":"ปฏิทินนัดหมาย","icon":"far fa-calendar-check","path":"/calendar","group_id":4,"menu_id":10,"menus":[]},{"name":"ตั้งค่า","icon":"fas fa-cog","path":"","group_id":5,"menu_id":0,"menus":[{"name":"ตั้งค่าสาขา","path":"/setting","group_id":5,"menu_id":1},{"name":"จัดการผู้ใช้งาน","path":"/usermenagement","group_id":5,"menu_id":2},{"name":"จัดการสิทธ์ผู้ใช้งาน","path":"/role_menage","group_id":5,"menu_id":3}]}]

/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"main-sidebar sidebar-dark-info elevation-4"},[_c('a',{staticClass:"brand-link navbar-dark",staticStyle:{"color":"white"}},[_c('img',{staticClass:"brand-image img-circle elevation-3 bg-white",attrs:{"src":_vm.CompanyConfig.logo_path || '../../static/logo.jpg',"alt":"POS MIS Logo"}}),_vm._v(" "),_c('span',{staticClass:"brand-text font-weight-dark ml-2"},[_vm._v(_vm._s(_vm.CompanyConfig.title_web))])]),_vm._v(" "),_c('div',{staticClass:"sidebar navbar-dark os-host os-theme-light os-host-overflow os-host-overflow-y os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-transition"},[_c('nav',{staticClass:"mt-2"},[_c('ul',{staticClass:"nav nav-legacy nav-compact nav-sidebar flex-column nav-child-indent",attrs:{"data-widget":"treeview","role":"menu","data-accordion":"true"}},_vm._l((_vm.menu_data.menu_permision),function(g,i){return _c('li',{key:'gm' + i,staticClass:"nav-item",class:{ 'has-treeview': g.sub_menu.length > 0, 'menu-open': _vm.$route.meta.group_id === g.head_menu_id && g.sub_menu.length > 0 }},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(g.is_read == 1),expression:"g.is_read == 1"}],staticClass:"nav-link",class:{ 'active': _vm.$route.meta.group_id === g.head_menu_id  },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.$router.push(g.head_path); _vm.checkDisplay(g.sub_menu.length)}}},[_c('i',{staticClass:"nav-icon",class:g.head_menu_icon}),_vm._v(" "),_c('p',[_vm._v("\n              "+_vm._s(g.head_menu_name)+"\n              "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(g.sub_menu.length > 0),expression:"g.sub_menu.length > 0"}],staticClass:"right fas fa-angle-left"})])]),_vm._v(" "),_c('ul',{staticClass:"nav-treeview"},_vm._l((g.sub_menu),function(m,k){return _c('li',{key:'me' + k,staticClass:"nav-item"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(m.is_read == 1),expression:"m.is_read == 1"}],staticClass:"nav-link",class:{ 'active': _vm.$route.meta.menu_id === m.menu_id },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.$router.push(m.menu_link); _vm.subCheckDisplay()}}},[_c('i',{staticClass:"nav-icon",class:{ 'far fa-dot-circle': _vm.$route.meta.menu_id === m.menu_id, 'far fa-circle': _vm.$route.meta.menu_id !== m.menu_id }}),_vm._v(" "),_c('p',[_vm._v(_vm._s(m.menu_name))])])])}),0)])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 525:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('SliderView',{staticStyle:{"display":"none"}}),_vm._v(" "),_c('loading',{attrs:{"active":_vm.$store.state.isLoading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){return _vm.$set(_vm.$store.state, "isLoading", $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(529);


var Main = function Main() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1047));
};
var Error404 = function Error404() {
  return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1048));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1049));
};
var Profile = function Profile() {
  return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1050));
};
var ForgotPass = function ForgotPass() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1051));
};

var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1052));
};

// const Blankpage = () => import('../views/Blank_page')
var Vendor = function Vendor() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1053));
};
var Customer = function Customer() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1054));
};

var Setting = function Setting() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1055));
};
var RoleMenage = function RoleMenage() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1056));
};
var RoleList = function RoleList() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1057));
};
var ManageUser = function ManageUser() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1058));
};
var ReportSale = function ReportSale() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1059));
};
var Calendar = function Calendar() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1060));
};

var ItemList = function ItemList() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1061));
};
var ManageItem = function ManageItem() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1062));
};

// ราคากลาง
var ItemPriceList = function ItemPriceList() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1063));
};
var ManagePriceItem = function ManagePriceItem() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1064));
};

var ManageBill = function ManageBill() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1065));
};
var ManageCategory = function ManageCategory() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1066));
};
var ManageStorage = function ManageStorage() {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1067));
};
var ReceiveList = function ReceiveList() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1068));
};
var ReturnList = function ReturnList() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1069));
};
var ReportExpend = function ReportExpend() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1070));
};
var ReportCostSale = function ReportCostSale() {
  return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1071));
};
var ReportCostStandard = function ReportCostStandard() {
  return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1072));
};
var ReportSaleItem = function ReportSaleItem() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1073));
};
var ReportProductMovement = function ReportProductMovement() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1074));
};
var ReportDaily = function ReportDaily() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1075));
};
var ReportSaleSummary = function ReportSaleSummary() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1076));
};
var ReportStock = function ReportStock() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1077));
};
var ReportHoldingCus = function ReportHoldingCus() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1078));
};
var ReportCancelBill = function ReportCancelBill() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1079));
};
var ReportHoldingRemain = function ReportHoldingRemain() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1080));
};
var ReportHoldingInvoice = function ReportHoldingInvoice() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1081));
};
var ReportSaleByCustomer = function ReportSaleByCustomer() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1082));
};
var ReportIncome = function ReportIncome() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1083));
};
var ReportStockStandard = function ReportStockStandard() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1084));
};
var ReportYearlySale = function ReportYearlySale() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1085));
};
var ReportCalculateRice = function ReportCalculateRice() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1086));
};
var PaymentCreditBill = function PaymentCreditBill() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1087));
};
var PrintInv = function PrintInv() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1088));
};
var ReportSaleType = function ReportSaleType() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1089));
};
var UserMenagement = function UserMenagement() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1090));
};
var AdjustList = function AdjustList() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1091));
};
var StkManage = function StkManage() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1092));
};
var StkGetManage = function StkGetManage() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1093));
};
var StandardList = function StandardList() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1094));
};
// const AdjustItem = () => import('../views/adjust_item')
// const ShortStorage = () => import('../views/shot_storage')
var ReportStkList = function ReportStkList() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1095));
};
var ReportStkEggList = function ReportStkEggList() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1096));
};
var StkBalance = function StkBalance() {
  return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1097));
};
var StkAmount = function StkAmount() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1098));
};
var TaxInvoice = function TaxInvoice() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1099));
};

var RiceStk = function RiceStk() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1100));
};

var originalPush = __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push;
__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var titlename = ' | POS MIS';

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  base: __dirname,
  routes: [{
    path: '/',
    redirect: '/',
    name: 'Main',
    component: Main,
    children: [{
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: { title: 'Dashboard', group_id: 5, menu_id: 0 }
    }, {
      path: '/report_yearly_sale',
      name: 'report_yearly_sale',
      component: ReportYearlySale,
      meta: { title: 'รายงานสรุปยอดขายประจำเดือน', group_id: 16, menu_id: 0 }
    }, {
      path: '/report_calculate_rice',
      name: 'report_calculate_rice',
      component: ReportCalculateRice,
      meta: { title: 'รายงานคำนวณข้าวนึ่ง', group_id: 17, menu_id: 0 }
    }, {
      path: '/itemlist',
      name: 'itemlist',
      component: ItemList,
      meta: { title: 'จัดการสินค้า', group_id: 6, menu_id: 2 }
    }, {
      path: '/manageitem/:branch_id/:id',
      name: 'manageitem',
      component: ManageItem,
      meta: { title: 'ข้อมูลสินค้า', group_id: 2, menu_id: 2 }
    }, {
      path: '/itemprice',
      name: 'itemprice',
      component: ItemPriceList,
      meta: { title: 'จัดการราคากลาง', group_id: 20, menu_id: 1 }
    }, {
      path: '/rice_stk',
      name: 'rice_stk',
      component: RiceStk,
      meta: { title: 'จัดการข้าวหม่า', group_id: 20, menu_id: 2 }
    }, {
      path: '/managepriceitem/:id',
      name: 'managepriceitem',
      component: ManagePriceItem,
      meta: { title: 'ข้อมูลสินค้าราคากลาง', group_id: 7, menu_id: 4 }
    }, {
      path: '/managecategory',
      name: 'managecategory',
      component: ManageCategory,
      meta: { title: 'จัดการหมวดหมู่', group_id: 2, menu_id: 2 }
    }, {
      path: '/receivelist',
      name: 'receivelist',
      component: ReceiveList,
      meta: { title: 'บันทึกรับสินค้าเข้า', group_id: 6, menu_id: 3 }
    }, {
      path: '/managestorage/:branch_id/:code',
      name: 'managestorage',
      component: ManageStorage,
      meta: { title: 'รับสินค้าเข้า', group_id: 2, menu_id: 3 }
    }, {
      path: '/returnlist',
      name: 'returnlist',
      component: ReturnList,
      meta: { title: 'บันทึกส่งคืนสินค้า', group_id: 2, menu_id: 4 }
    }, {
      path: '/report_sale',
      name: 'reportsale',
      component: ReportSale,
      meta: { title: 'รายงานขายประจำวัน', group_id: 11, menu_id: 5 }
    }, {
      path: '/reportitem',
      name: 'reportitem',
      component: ReportSaleItem,
      meta: { title: 'ยอดขายสินค้าประจำวัน', group_id: 6, menu_id: 17 }
    }, {
      path: '/reportcoststandard',
      name: 'reportcoststandard',
      component: ReportCostStandard,
      meta: { title: 'รายงานต้นทุนมาตราฐาน', group_id: 6, menu_id: 23 }
    }, {
      path: '/reportcostofsales',
      name: 'reportcostofsales',
      component: ReportCostSale,
      meta: { title: 'รายงานกำไรขั้นต้น', group_id: 6, menu_id: 6 }
    }, {
      path: '/reportexpend',
      name: 'reportexpend',
      component: ReportExpend,
      meta: { title: 'รายงานค่าใช้จ่าย', group_id: 6, menu_id: 8 }
    }, {
      path: '/reportstock',
      name: 'reportstock',
      component: ReportStock,
      meta: { title: 'รายงานสต๊อกสินค้า', group_id: 6, menu_id: 9 }
    }, {
      path: '/reportmovement',
      name: 'reportmovement',
      component: ReportProductMovement,
      meta: { title: 'รายงานเคลื่อนไหวสินค้า', group_id: 6, menu_id: 11 }
    }, {
      path: '/reportdaily',
      name: 'reportdaily',
      component: ReportDaily,
      meta: { title: 'รายงานนำส่งเงิน', group_id: 6, menu_id: 7 }
    }, {
      path: '/reportsalesummary',
      name: 'reportsalesummary',
      component: ReportSaleSummary,
      meta: { title: 'รายงานสรุปการขาย', group_id: 6, menu_id: 10 }
    }, {
      path: '/reportholdingcus',
      name: 'reportholdingcus',
      component: ReportHoldingCus,
      meta: { title: 'รายงานพักบิลตามวันที่', group_id: 6, menu_id: 12 }
    }, {
      path: '/reportbillcancel',
      name: 'reportbillcancel',
      component: ReportCancelBill,
      meta: { title: 'รายงานยกเลิกบิล', group_id: 6, menu_id: 15 }
    }, {
      path: '/reportholdingremain',
      name: 'reportholdingremain',
      component: ReportHoldingRemain,
      meta: { title: 'รายงานพักบิลค้างชำระ', group_id: 6, menu_id: 13 }
    }, {
      path: '/reportholdinginvoice',
      name: 'reportholdinginvoice',
      component: ReportHoldingInvoice,
      meta: { title: 'รายงานสรุปสถานะใบพักบิล', group_id: 6, menu_id: 21 }
    }, {
      path: '/reportsalebycustomer',
      name: 'reportsalebycustomer',
      component: ReportSaleByCustomer,
      meta: { title: 'รายงานสรุปยอดขายตามลูกค้า', group_id: 6, menu_id: 14 }
    }, {
      path: '/reportsaletype',
      name: 'reportsaletype',
      component: ReportSaleType,
      meta: { title: 'รายงานขายตามประเภทรับชำระ', group_id: 6, menu_id: 16 }
    }, {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
      meta: { title: 'ปฏิทินนัดหมาย', group_id: 12, menu_id: 0 }
    }, {
      path: '/setting',
      name: 'setting',
      component: Setting,
      meta: { title: 'ตั้งค่าระบบ', group_id: 13, menu_id: 18 }
    }, {
      path: '/role_menage',
      name: 'role_menage',
      component: RoleList,
      meta: { title: 'จัดการสิทธิ์ผู้ใช้งาน', group_id: 13, menu_id: 20 }
    }, {
      path: '/role_menage_detail/:role_code',
      name: 'role_menage_detail',
      component: RoleMenage,
      meta: { title: 'จัดการสิทธิ์ผู้ใช้งาน', group_id: 13, menu_id: 20 }
    }, {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: { title: 'ข้อมูลผู้ใช้งานระบบ', group_id: 1, menu_id: 1 }
    }, {
      path: '/vendor',
      name: 'vendor',
      component: Vendor,
      meta: { title: 'จัดการข้อมูลเจ้าหนี้', group_id: 8, menu_id: 0 }
    }, {
      path: '/customer',
      name: 'customer',
      component: Customer,
      meta: { title: 'จัดการข้อมูลลูกหนี้', group_id: 9, menu_id: 0 }
    }, {
      path: '/managebill',
      name: 'managebill',
      component: ManageBill,
      meta: { title: 'จัดการบิล', group_id: 8, menu_id: 17 }
    }, {
      path: '/paycredit',
      name: 'paycredit',
      component: PaymentCreditBill,
      meta: { title: 'รับชำระเงินเชื่อ', group_id: 9, menu_id: 18 }
    }, {
      path: '/printinv',
      name: 'printinv',
      component: PrintInv,
      meta: { title: 'รายการพักบิล', group_id: 10, menu_id: 0 }
    }, {
      path: '/tax_invoice',
      name: 'tax_invoice',
      component: TaxInvoice,
      meta: { title: 'จัดการใบกำกับภาษี', group_id: 15, menu_id: 0 }
    }, {
      path: '/usermenagement',
      name: 'usermenagement',
      component: UserMenagement,
      meta: { title: 'จัดการผู้ใช้งาน', group_id: 13, menu_id: 19 }
    }, {
      path: '/editusers/:user_code',
      name: 'editusers',
      component: ManageUser,
      meta: { title: 'จัดการผู้ใช้งาน', group_id: 13, menu_id: 19 }
    }, {
      path: '/adjust_list',
      name: 'adjust_list',
      component: AdjustList,
      meta: { title: 'ปรับปรุงต้นทุนสินค้า', group_id: 3, menu_id: 22 }
    }, {
      path: '/standart_list',
      name: 'standart_list',
      component: StandardList,
      meta: { title: 'ปรับปรุงต้นทุนสินค้า', group_id: 3, menu_id: 24 }
    }, {
      path: '/stock_manage',
      name: 'stock_manage',
      component: StkManage,
      meta: { title: 'จัดการโอนย้ายสินค้า', group_id: 3, menu_id: 35 }
    }, {
      path: '/stock_get_manage',
      name: 'stock_get_manage',
      component: StkGetManage,
      meta: { title: 'สั่งสินค้าโกดัง', group_id: 3, menu_id: 37 }
    }, {
      path: '/report_income',
      name: 'report_income',
      component: ReportIncome,
      meta: { title: 'รายงานนำเงินเข้า', group_id: 6, menu_id: 25 }
    }, {
      path: '/report_stock_standard',
      name: 'report_stock_standard',
      component: ReportStockStandard,
      meta: { title: 'รายงานต้นทุนตามสินค้า', group_id: 6, menu_id: 26 }
    },

    // {
    //   path: '/short_storage',
    //   name: 'short_storage',
    //   component: ShortStorage,
    //   meta: { title: 'ใบนับสต๊อกสินค้า', group_id: 3, menu_id: 28 }
    // },
    {
      path: '/report_stk',
      name: 'report_stk',
      component: ReportStkList,
      meta: { title: 'รายงานสรุปยอดคงเหลือ', group_id: 3, menu_id: 29 }
    }, {
      path: '/report_stk_egg',
      name: 'report_stk_egg',
      component: ReportStkEggList,
      meta: { title: 'รายงานสรุปคงเหลือไข่', group_id: 3, menu_id: 36 }
    }, {
      path: '/stk_balance',
      name: 'stk_balance',
      component: StkBalance,
      meta: { title: 'ยอดยกสินค้ามา', group_id: 3, menu_id: 27 }
    }, {
      path: '/stk_amount',
      name: 'stk_amount',
      component: StkAmount,
      meta: { title: 'บันทึกนับสต๊อก', group_id: 3, menu_id: 27 }
    }]
  }, {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { title: 'เข้าสู่ระบบ' }
  }, {
    path: '/forgot',
    name: 'forgot',
    component: ForgotPass,
    meta: { title: 'ลืมรหัสผ่าน' }
  }, {
    path: '*',
    name: 'P404',
    component: Error404,
    meta: { title: 'Error Page' }
  }]
});

var DEFAULT_TITLE = titlename;
router.afterEach(function (to, from) {
  document.title = to.meta.title + titlename || DEFAULT_TITLE + titlename;
});

/* harmony default export */ __webpack_exports__["a"] = (router);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 219,
	"./af.js": 219,
	"./ar": 220,
	"./ar-dz": 221,
	"./ar-dz.js": 221,
	"./ar-kw": 222,
	"./ar-kw.js": 222,
	"./ar-ly": 223,
	"./ar-ly.js": 223,
	"./ar-ma": 224,
	"./ar-ma.js": 224,
	"./ar-sa": 225,
	"./ar-sa.js": 225,
	"./ar-tn": 226,
	"./ar-tn.js": 226,
	"./ar.js": 220,
	"./az": 227,
	"./az.js": 227,
	"./be": 228,
	"./be.js": 228,
	"./bg": 229,
	"./bg.js": 229,
	"./bm": 230,
	"./bm.js": 230,
	"./bn": 231,
	"./bn-bd": 232,
	"./bn-bd.js": 232,
	"./bn.js": 231,
	"./bo": 233,
	"./bo.js": 233,
	"./br": 234,
	"./br.js": 234,
	"./bs": 235,
	"./bs.js": 235,
	"./ca": 236,
	"./ca.js": 236,
	"./cs": 237,
	"./cs.js": 237,
	"./cv": 238,
	"./cv.js": 238,
	"./cy": 239,
	"./cy.js": 239,
	"./da": 240,
	"./da.js": 240,
	"./de": 241,
	"./de-at": 242,
	"./de-at.js": 242,
	"./de-ch": 243,
	"./de-ch.js": 243,
	"./de.js": 241,
	"./dv": 244,
	"./dv.js": 244,
	"./el": 245,
	"./el.js": 245,
	"./en-au": 246,
	"./en-au.js": 246,
	"./en-ca": 247,
	"./en-ca.js": 247,
	"./en-gb": 248,
	"./en-gb.js": 248,
	"./en-ie": 249,
	"./en-ie.js": 249,
	"./en-il": 250,
	"./en-il.js": 250,
	"./en-in": 251,
	"./en-in.js": 251,
	"./en-nz": 252,
	"./en-nz.js": 252,
	"./en-sg": 253,
	"./en-sg.js": 253,
	"./eo": 254,
	"./eo.js": 254,
	"./es": 255,
	"./es-do": 256,
	"./es-do.js": 256,
	"./es-mx": 257,
	"./es-mx.js": 257,
	"./es-us": 258,
	"./es-us.js": 258,
	"./es.js": 255,
	"./et": 259,
	"./et.js": 259,
	"./eu": 260,
	"./eu.js": 260,
	"./fa": 261,
	"./fa.js": 261,
	"./fi": 262,
	"./fi.js": 262,
	"./fil": 263,
	"./fil.js": 263,
	"./fo": 264,
	"./fo.js": 264,
	"./fr": 265,
	"./fr-ca": 266,
	"./fr-ca.js": 266,
	"./fr-ch": 267,
	"./fr-ch.js": 267,
	"./fr.js": 265,
	"./fy": 268,
	"./fy.js": 268,
	"./ga": 269,
	"./ga.js": 269,
	"./gd": 270,
	"./gd.js": 270,
	"./gl": 271,
	"./gl.js": 271,
	"./gom-deva": 272,
	"./gom-deva.js": 272,
	"./gom-latn": 273,
	"./gom-latn.js": 273,
	"./gu": 274,
	"./gu.js": 274,
	"./he": 275,
	"./he.js": 275,
	"./hi": 276,
	"./hi.js": 276,
	"./hr": 277,
	"./hr.js": 277,
	"./hu": 278,
	"./hu.js": 278,
	"./hy-am": 279,
	"./hy-am.js": 279,
	"./id": 280,
	"./id.js": 280,
	"./is": 281,
	"./is.js": 281,
	"./it": 282,
	"./it-ch": 283,
	"./it-ch.js": 283,
	"./it.js": 282,
	"./ja": 284,
	"./ja.js": 284,
	"./jv": 285,
	"./jv.js": 285,
	"./ka": 286,
	"./ka.js": 286,
	"./kk": 287,
	"./kk.js": 287,
	"./km": 288,
	"./km.js": 288,
	"./kn": 289,
	"./kn.js": 289,
	"./ko": 290,
	"./ko.js": 290,
	"./ku": 291,
	"./ku.js": 291,
	"./ky": 292,
	"./ky.js": 292,
	"./lb": 293,
	"./lb.js": 293,
	"./lo": 294,
	"./lo.js": 294,
	"./lt": 295,
	"./lt.js": 295,
	"./lv": 296,
	"./lv.js": 296,
	"./me": 297,
	"./me.js": 297,
	"./mi": 298,
	"./mi.js": 298,
	"./mk": 299,
	"./mk.js": 299,
	"./ml": 300,
	"./ml.js": 300,
	"./mn": 301,
	"./mn.js": 301,
	"./mr": 302,
	"./mr.js": 302,
	"./ms": 303,
	"./ms-my": 304,
	"./ms-my.js": 304,
	"./ms.js": 303,
	"./mt": 305,
	"./mt.js": 305,
	"./my": 306,
	"./my.js": 306,
	"./nb": 307,
	"./nb.js": 307,
	"./ne": 308,
	"./ne.js": 308,
	"./nl": 309,
	"./nl-be": 310,
	"./nl-be.js": 310,
	"./nl.js": 309,
	"./nn": 311,
	"./nn.js": 311,
	"./oc-lnc": 312,
	"./oc-lnc.js": 312,
	"./pa-in": 313,
	"./pa-in.js": 313,
	"./pl": 314,
	"./pl.js": 314,
	"./pt": 315,
	"./pt-br": 316,
	"./pt-br.js": 316,
	"./pt.js": 315,
	"./ro": 317,
	"./ro.js": 317,
	"./ru": 318,
	"./ru.js": 318,
	"./sd": 319,
	"./sd.js": 319,
	"./se": 320,
	"./se.js": 320,
	"./si": 321,
	"./si.js": 321,
	"./sk": 322,
	"./sk.js": 322,
	"./sl": 323,
	"./sl.js": 323,
	"./sq": 324,
	"./sq.js": 324,
	"./sr": 325,
	"./sr-cyrl": 326,
	"./sr-cyrl.js": 326,
	"./sr.js": 325,
	"./ss": 327,
	"./ss.js": 327,
	"./sv": 328,
	"./sv.js": 328,
	"./sw": 329,
	"./sw.js": 329,
	"./ta": 330,
	"./ta.js": 330,
	"./te": 331,
	"./te.js": 331,
	"./tet": 332,
	"./tet.js": 332,
	"./tg": 333,
	"./tg.js": 333,
	"./th": 334,
	"./th.js": 334,
	"./tk": 335,
	"./tk.js": 335,
	"./tl-ph": 336,
	"./tl-ph.js": 336,
	"./tlh": 337,
	"./tlh.js": 337,
	"./tr": 338,
	"./tr.js": 338,
	"./tzl": 339,
	"./tzl.js": 339,
	"./tzm": 340,
	"./tzm-latn": 341,
	"./tzm-latn.js": 341,
	"./tzm.js": 340,
	"./ug-cn": 342,
	"./ug-cn.js": 342,
	"./uk": 343,
	"./uk.js": 343,
	"./ur": 344,
	"./ur.js": 344,
	"./uz": 345,
	"./uz-latn": 346,
	"./uz-latn.js": 346,
	"./uz.js": 345,
	"./vi": 347,
	"./vi.js": 347,
	"./x-pseudo": 348,
	"./x-pseudo.js": 348,
	"./yo": 349,
	"./yo.js": 349,
	"./zh-cn": 350,
	"./zh-cn.js": 350,
	"./zh-hk": 351,
	"./zh-hk.js": 351,
	"./zh-mo": 352,
	"./zh-mo.js": 352,
	"./zh-tw": 353,
	"./zh-tw.js": 353
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 576;

/***/ }),

/***/ 581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation__ = __webpack_require__(583);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  user: [],
  token: null,
  screenHeight: 0,
  screenWidth: 0,
  isLoading: false,
  config: {},
  btnbottom: false,
  historyPage: '',
  currentPath: '',
  order_data: {
    'host_code': '',
    'ar_code': '',
    'tax_rate': 7,
    'discount_word': '',
    'discount_amount': 0,
    'item_amount': 0,
    'bill_type': 0,
    'cash_amount': 0,
    'credit_card_amount': 0,
    'sub': []
  },
  item_subs: [],
  branch_list: null
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutation__,
  state: state
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["clearState"] = clearState;
/* harmony export (immutable) */ __webpack_exports__["clearOrderPayment"] = clearOrderPayment;
/* harmony export (immutable) */ __webpack_exports__["Loading"] = Loading;
function clearState(state) {
  state.user = [];
  sessionStorage.clear();
}

function clearOrderPayment(state) {
  state.order_data = {
    'host_code': '',
    'ar_code': '',
    'tax_rate': 7,
    'discount_word': '',
    'discount_amount': 0,
    'item_amount': 0,
    'bill_type': 0,
    'cash_amount': 0,
    'credit_card_amount': 0,
    'sub': []
  };
  state.item_subs = [];
}

function Loading(state) {
  state.isLoading = !state.isLoading;
}

/***/ })

},[518]);


// WEBPACK FOOTER //
// static/js/app.a3211cb2b80c2f6fff18.js